import React from 'react';
import { Request } from './lib/Request';
import { configureStore } from './store';
import { ConnectedApp } from './components/App';
import { Provider } from 'react-redux';

export function renderApp({ pkgVersion, version, ...props }) {
  const request = new Request({
    spotifyAppVersion: `${pkgVersion}.${version}`,
  });

  const context = {
    request,
    pkgVersion,
    version,
  };

  const store = configureStore(undefined, context);

  return (
    <Provider store={store}>
      <ConnectedApp {...props} />
    </Provider>
  );
}
